import { Fragment, useEffect, useState } from 'react';
import { toAbsoluteUrl } from '@/utils/Assets';
import { Container } from '@/components/container';
import { MatchContent } from './';
import { Navbar } from "@/partials/navbar";
import { PageMenu } from './menu/PageMenu.tsx';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { KeenIcon } from "@/components";
import { MatchProfileHero } from "@/pages/buddy/match/hero/MatchPofileHero.tsx";
import { MatchDetailsData } from "@/pages/buddy/types/MatchDetailsData.ts";
import { Loading } from '@/layouts/buddy/loading';
import { enqueueSnackbar } from "notistack";

const MatchPage = () => {
    const [match, setMatch] = useState<MatchDetailsData | null>(null);
    const [loading, setLoading] = useState(true);
    const [activePage, setActivePage] = useState<string>('overview');

    const { p_id } = useParams<{ p_id: string }>();
    const API_MATCH = `${import.meta.env.VITE_APP_API_URL}/match`;

    // 1️⃣ Fetch function now returns a Promise<void> to use as onRefresh
    const fetchMatchData = async (): Promise<void> => {
        try {
            const response = await axios.get<MatchDetailsData>(`${API_MATCH}/${p_id}`, {
                headers: { Accept: 'application/json' },
            });
            console.log("Fetched data:", response.data);
            setMatch(response.data);
        } catch (err) {
            enqueueSnackbar(`Failed to fetch match data: ${err}`, {
                variant: 'solid',
                state: 'danger'
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMatchData();
    }, [p_id]);

    if (loading) return <Loading loading={loading} />;
    if (!match)  return <div>No match data available</div>;

    return (
        <Fragment>
            <MatchProfileHero match={match} />

            <Container>
                <Navbar>
                    <PageMenu setActivePage={setActivePage} />
                </Navbar>
            </Container>

            <Container>
                {/* 2️⃣ Pass fetchMatchData down as onRefresh */}
                <MatchContent
                    activePage={activePage}
                    match={match}
                    onRefresh={fetchMatchData}
                />
            </Container>
        </Fragment>
    );
};

export { MatchPage };
